import React from 'react';
import "./compactTypeSwitch.css";

function CompactTypeSwitch({options, value, onChange, className = "", ariaLabel = "선택"}) {
    return (
        <div className={`compact-type-switch ${className}`.trim()} role="radiogroup" aria-label={ariaLabel}>
            {options.map((option) => {
                const optionValue = option.value ?? option.id;
                const isActive = value === optionValue;
                return (
                    <button
                        key={optionValue}
                        type="button"
                        role="radio"
                        aria-checked={isActive}
                        className={`compact-type-switch__btn ${isActive ? "is-active" : ""}`}
                        onClick={() => onChange(optionValue)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
}

export default CompactTypeSwitch;
